/**
 * @param {any} draft - Draft state.
 * @param {any} payload - Action payload.
 */
export const setEmptyRequest = (draft, payload) => {
    if (!draft.emptyRequests.some((req) => _.isEqual(req, payload))) {
        draft.emptyRequests = [...draft.emptyRequests, payload];
    }
};
